export default "__VITE_ASSET__DR9XvqRd__"